import { Box, Grid } from "@mui/material";
import { setSelectedFunctionalAreas } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import AssignPlan from "components/features/AboveProperty/PlanView/AssignPlan";
import ActionCardDialogsContext from "components/features/ActionCard/Context";
import Item from "components/features/Sections/Item/index";
import PlanDetailsContent from "components/features/planDetails/PlanDetailsContent";
import { useTranslate } from "hooks/useTranslate";
import { useContext, useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import colors from "styles/Colors";
import { tokens } from "styles/Tokens";
import { nestedTernaryCheckerCond2 } from "utils/CommonChecker";
import { DEFAULT_CORP_INNCODE, PAGE_SIZE, abovePropertyAssign, allPlansType } from "utils/CommonConstants";
import { functionalAreaIdsToNames, functionalAreaNamesToIds, getHltInncodes } from "utils/CommonFunctions";
import { planTypes } from "utils/Types";
import AssignPlanConfirmDialogs from "../AssignPlan/AssignPlanConfirmDialogs";
import Button from "../Button";
import Dialog from "../Dialog";
import DialogFormation from "../DialogFormation";
import PlanType from "../PlanType";
import Scroller from "../Scroller/InfiniteScroller";
import Typography from "../Typography";
import MultipleSelectCheckmarks from "../dropdowns/MultiSelect";
import SearchAppBar from "../searchBar";
import "./AssignMultiplePlansDialog.tsx.scss";
import PlanBar from "./PlanBar";
import SelectedPlansList from "./SelectedPlansList";
import { fetchPlansAsync } from "./plans.slice";

export default function AssignMultiplePlansDialog(props: any) {
  const translate = useTranslate();
  const {
    selectedInncodeList,
    handleCloseDialog,
    setOpenAssignPlanDialog,
    assignType,
    listId,
    onCloseConfirm,
    individualPropertyInncode
  } = props;
  const inncode = selectedInncodeList?.length > 1 ? DEFAULT_CORP_INNCODE : selectedInncodeList?.[0].innCode;
  const [pageNo, setPageNo] = useState(1);
  const [openDialog, setOpenDialog] = useState<any>({ openAssignPlanDialog: true, openMessageDialog: false });
  const { totalRecords, list } = useAppSelector((state) => state.plans);
  const functionalAreas = useAppSelector((state: any) => state.functionalAreas?.list);
  const selectedFunctionalAreas = useAppSelector((state: any) => state.app.selectedFunctionalAreas);
  const [checkedList, setCheckedList] = useState<any>([]);
  const [searchText, setSearchText] = useState<any>("");
  const [searchParams] = useSearchParams();
  const [openPropertyAssign, setOpenPropertyAssign] = useState<boolean>(false);
  const location = useLocation();
  const { isOpenPlanDetailDialog, setIsOpenPlanDetaiLDialog } = useContext(ActionCardDialogsContext);
  const { isMobileScreen } = useContext(ThemeContext);
  const { planDetails: selectedPlanDetail }: any = useAppSelector((state) => state.sme);
  const { isAbovePropertyUser }: any = useAppSelector((state) => state.app);
  const selectedInncode = individualPropertyInncode ?? getHltInncodes()[0];
  const getProps = (page?: number) => {
    return {
      filter: {
        innCode: isAbovePropertyUser ? selectedInncode : inncode,
        functionalAreaIds: selectedFunctionalAreas
      },
      pagination: {
        page: page ?? pageNo + 1,
        size: PAGE_SIZE
      },
      searchText: searchText,
      planType: [allPlansType]
    };
  };

  const dispatch = useAppDispatch();
  useEffect(() => {
    const props: any = getProps(1);
    dispatch(fetchPlansAsync(props));
  }, [selectedFunctionalAreas, searchText]);

  const fetchMore = () => {
    const props = getProps();
    dispatch(fetchPlansAsync(props));
    setPageNo(pageNo + 1);
  };
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, plan: any) => {
    if (event.target.checked) {
      if (checkedList.findIndex((element: any) => element?.id === plan?.id) < 0) {
        setCheckedList((prevState: any) => [...prevState, plan]);
      }
    } else {
      setCheckedList((prevState: any) => prevState.filter((item: any) => item?.id !== plan?.id));
    }
  };
  const handleState = () => {
    setIsOpenPlanDetaiLDialog(true);
    setOpenDialog({ openAssignPlanDialog: false });
  };
  const onMultiSelectChange = (value: any) => {
    const areaDetails = functionalAreaNamesToIds(value);
    dispatch(setSelectedFunctionalAreas(areaDetails));
  };
  const getInputDetails = (input: any) => {
    if (input.length > 2 || !input) {
      setSearchText(input);
    }
  };

  const handleAssignPlans = () => {
    if (assignType === abovePropertyAssign.multiple) {
      setOpenDialog({ openAssignPlanDialog: false });
      setOpenPropertyAssign(true);
    } else setOpenDialog({ openAssignPlanDialog: false, openMessageDialog: true });
  };

  return (
    <>
      {openDialog.openAssignPlanDialog && (
        <DialogFormation
          openDialog={openDialog?.openAssignPlanDialog}
          title={translate("dashboard.planAssignment.plan")}
          contentClass="planAssignmen-modal-content"
          actionConfig={
            <div className="modal-config-wrapper">
              <Button
                sx={isMobileScreen ? { width: "100%" } : {}}
                disabled={!checkedList.length}
                variant="primary"
                endIcon={
                  checkedList.length > 0 && (
                    <div className="next-count">
                      <Typography variant={"body2"} showBold>
                        {checkedList.length}
                      </Typography>
                    </div>
                  )
                }
                label="Next"
                onClick={handleAssignPlans}
              />
            </div>
          }
          handleClose={handleCloseDialog}
        >
          <Grid item display="flex" flexDirection={isMobileScreen ? "column" : "row"} justifyContent={"space-between"}>
            <SearchAppBar
              value={searchText}
              getInputDetails={getInputDetails}
              sx={{
                border: `1px solid  ${tokens.Border.General.Tertiary}`,
                marginTop: "8px",
                height: "44px"
              }}
            />
            <MultipleSelectCheckmarks
              name="Functional Area"
              label="Functional Area"
              minWidth={isMobileScreen ? "100%" : "180px"}
              options={functionalAreas}
              initialValues={functionalAreaIdsToNames(selectedFunctionalAreas)}
              onChange={(value: any) => onMultiSelectChange(value)}
            ></MultipleSelectCheckmarks>
          </Grid>

          <Grid
            sx={{
              backgroundColor: isMobileScreen ? "" : `${colors.Neutral.Neutral50}`,
              border: `solid 1px ${colors.Neutral.Neutral200}`,
              paddingLeft: "8px"
            }}
          >
            {checkedList?.length > 0 && (
              <Grid display="flex" justifyContent="flex-end" alignItems="center">
                <Typography variant="body2" showBold color={tokens.Text.General.Secondary}>
                  {checkedList?.length} plans selected
                </Typography>
                <SelectedPlansList
                  options={checkedList}
                  handleChange={(option: any) =>
                    setCheckedList((prevState: any) => prevState.filter((item: any) => item?.id !== option?.id))
                  }
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                ></SelectedPlansList>
              </Grid>
            )}
            <Box
              id="assignMultiPlansGrid"
              overflow="auto"
              maxHeight={nestedTernaryCheckerCond2(
                isMobileScreen,
                checkedList?.length > 0,
                "calc(100vh - 270px)",
                "270px",
                "300px"
              )}
            >
              <Scroller
                dataLength={list?.length}
                loadMore={fetchMore}
                totalList={totalRecords}
                label="Plans"
                scrollableTarget="assignMultiPlansGrid"
              >
                {list?.map((plan: any) => {
                  return (
                    <>
                      <PlanBar
                        key={plan?.id}
                        plan={plan}
                        checkedList={checkedList}
                        handleCheckboxChange={(e, plan) => handleCheckboxChange(e, plan)}
                        handleState={handleState}
                        selectedInncode={isAbovePropertyUser ? selectedInncode : inncode}
                      />
                    </>
                  );
                })}
              </Scroller>
            </Box>
          </Grid>
        </DialogFormation>
      )}
      <Dialog
        Open={isOpenPlanDetailDialog}
        handleCloseDialog={() => {
          setIsOpenPlanDetaiLDialog(false);
          setOpenDialog({ openAssignPlanDialog: true });
        }}
        sx={{
          dialog: { maxWidth: "md" },
          dialogPaper: { backgroundColor: colors.Neutral.Neutral100 },
          closeBox: { margin: "24px 24px 24px auto" },
          dialogContent: { margin: "0", padding: "0" },
          dialogAction: { display: "none" }
        }}
      >
        <Grid width="calc(100% - 32px)" sx={{ boxSizing: "border-box", textAlign: "left" }}>
          <Grid padding="16px" sx={{ backgroundColor: tokens.Background.General.Primary }}>
            {selectedPlanDetail?.planType && location?.pathname?.split("/")[1] === "userview" && isAbovePropertyUser ? (
              <Box marginBottom={"8px"}>
                <PlanType
                  planType={selectedPlanDetail?.planType}
                  brandDeadlineDate={
                    selectedPlanDetail?.brandDeadlines && selectedPlanDetail?.brandDeadlines[0]?.deadline
                  }
                  initiativeName={selectedPlanDetail?.initiativeName}
                />
              </Box>
            ) : (
              <></>
            )}
            <PlanDetailsContent selectedPlanDetail={selectedPlanDetail} plansType={planTypes.MulipleAssign} />
          </Grid>
          <Grid marginBottom={"16px"} marginTop={"16px"}>
            <Typography component="div" variant="h4" showBold color={tokens.Text.General.PrimaryBody} textAlign="left">
              Action plan
            </Typography>
          </Grid>
          <Grid>
            {selectedPlanDetail?.sections?.length > 0 &&
              selectedPlanDetail?.sections?.map((section: any, index: number) => {
                return (
                  <Item
                    key={section.id}
                    section={section}
                    index={index}
                    planType={planTypes.MulipleAssign}
                    planId={selectedPlanDetail?.id}
                  />
                );
              })}
          </Grid>
        </Grid>
      </Dialog>
      {openDialog.openMessageDialog && (
        <AssignPlanConfirmDialogs
          handleCloseState={setOpenAssignPlanDialog}
          selectedList={selectedInncodeList}
          SelectedPlansList={checkedList}
          handleBackState={setOpenDialog}
          innCode={isAbovePropertyUser && searchParams.get("inncode") ? searchParams.get("inncode") : inncode}
          listId={listId}
          onCloseConfirm={onCloseConfirm}
        />
      )}
      {openPropertyAssign && (
        <AssignPlan
          setOpenAssignPlanDialog={setOpenAssignPlanDialog}
          handleCloseDialog={handleCloseDialog}
          selectedPlanDetail={selectedPlanDetail}
          SelectedPlansList={checkedList}
          showBackButton={true}
          handleBackState={() => {
            setOpenDialog({ openAssignPlanDialog: true });
            setOpenPropertyAssign(false);
          }}
        />
      )}
    </>
  );
}
